import { MultiValueFilterOperation } from '../multi-value-filter-operation.enum';
import { SingleValueFilterOperation } from '../single-value-filter-operation.enum';

export const filterOperationStrings: string[] = [
   '<',
   '<=',
   '>',
   '>=',
   '!=',
   '=',
   'in',
   'not in',
   'between',
   'contains',
   'starts with',
   'ends with',
   'is',
];

export enum HasValueFilterOperation {
   HasValue = 'HasValue',
}

export type FilterOperations = HasValueFilterOperation | MultiValueFilterOperation | SingleValueFilterOperation;
export const FilterOperations = {
   ...MultiValueFilterOperation,
   ...SingleValueFilterOperation,
   ...HasValueFilterOperation,
};
